import React, { useState } from 'react';
import Button from 'common/components/elements/buttons/primary';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import paymentMethodImage from 'common/utils/import-payment-image';
import getPaymentMethodName from './payment-method-names';
import IntercomMoreInfo, { MEMBER_PAYMENT_FAQS, CONTACT_SUPPORT } from 'sites/utils/IntercomMoreInfo';
import NumberFormatter from 'common/utils/NumberFormatter';

import { getSiteTitle } from 'common/utils/helper';
import './style.scss'
import IconLabel from 'common/components/elements/icon-label';

const numberFormatter = new NumberFormatter();

const ChoosePaymentType = ({
   onModalClose,
   onContinue,
   isDisabled,
   savedPaymentMethod,
   type,
   methods,
   onOneClickPay,
   showNewStyles,
   purchaseData,
   isMobile,
}) => {

   let defaultType = 'other'
   if(!!methods.one_click) defaultType = 'one_click'
   if(!!methods.wallet) defaultType = 'wallet'
   if(!!methods.wallet && methods.wallet.balance === 0 && !!methods.one_click) defaultType = "one_click"
   if(type === 'store' && !!methods.wallet && methods.wallet.balance === 0 && !methods.one_click) defaultType = "other"
   const [selectedMethod, setPaymentMethod] = useState(defaultType);
   let buttonText = 'Continue';
   let buttonAction = () => onContinue(selectedMethod)

   if(type === 'tip') {
      if(selectedMethod === 'wallet') {
         buttonText = 'Send tip';
      }
      if(selectedMethod === 'other') {
         buttonText = 'Choose another method';
      }
      if(selectedMethod === 'card') {
         if(!!savedPaymentMethod) {
            buttonText =  `Tip with ${ getPaymentMethodName(savedPaymentMethod.payment_method) }`
         }
      }
   } else {
      if(!!savedPaymentMethod) {
         buttonText = 'Buy now';
      }
   }
   if(selectedMethod === 'one_click') {
      buttonText = 'Pay'
      buttonAction = () => onOneClickPay()
   }
   const {
      wallet,
      one_click,
      another_payment_options,
      payment_limits,
   } = methods;

   // const {
   //    current_number_of_payments_in_30_days,
   //    max_number_of_payments_in_30_days,
   // } = payment_limits;
   const current_number_of_payments_in_30_days = payment_limits?.current_number_of_payments_in_30_days
   const max_number_of_payments_in_30_days = payment_limits?.max_number_of_payments_in_30_days
   let diffPerecentage = (current_number_of_payments_in_30_days / max_number_of_payments_in_30_days) * 100;
   let diff = max_number_of_payments_in_30_days - current_number_of_payments_in_30_days;
   return (
      <div
         style={ { maxHeight: window.innerHeight - 40 } }
         className='w-full'>
         <div className='header-shadow px-4 py-3 flex items-center'>
            {
               type === 'store' ?
                  <div className=' w-full'>
                     <div className=' w-full !py-1 !pb-4'>
                        <div className='w-6 h-6 '>
                           <Button
                              iconName='close'
                              fontIconSize='extraLarge'
                              fontIconColor='major'
                              darkIconcolor='major-dark'
                              padding='none'
                              classNames='w-full h-full'
                              backgroundColor='transparent'
                              onClick={ onModalClose }
                           />
                        </div>
                     </div>
                     <div className='w-full flex flex-col items-center'>
                        <IconLabel
                           name='store'
                           isPrimary={ true }
                           className='w-10 h-10'
                           size='[20px]'
                        />
                        <p
                           // notranslate-content-title
                           className='text-xl font-semibold dark:text-major-dark mt-3 notranslate'
                        >
                           {purchaseData?.name}
                        </p>
                     </div>
                  </div>
                  :
                  <>
                     <div className='w-6 h-6'>
                        <Button
                           iconName='close'
                           fontIconColor='major'
                           darkIconcolor='major-dark'
                           classNames='h-full w-full'
                           backgroundColor='transparent'
                           waveColor='rgba(33, 33, 33, 0.8)'
                           padding='none'
                           onClick={ onModalClose }
                        />
                     </div>
                     <span className='leading-tight text-major dark:text-major-dark'> Payment method </span>
                  </>
            }
         </div>

         <div className={ type === 'store' ? `w-full flex px-6 pb-8 ${ isMobile ? 'flex-col gap-8' : 'flex-row gap-10' }` : '' }>
            {
               type === 'store' ?
                  <div className={ `w-full mt-6 flex ${ isMobile ? 'flex-col gap-8' : 'flex-row gap-10' }` }>
                     <div className='flex flex-col gap-6'>
                        <div className='flex flex-col gap-2 items-start '>
                           <span className='text-sm font-medium dark:text-major-dark'>Order summary</span>
                           <div className={ `${ isMobile ? 'w-full' : 'w-[327px]' } border dark:border-grey-dm p-4 rounded-lg flex flex-col gap-4` }>
                              <div className='flex flex-row justify-between items-center text-sm gap-2'>
                                 <span className='dark:text-major-dark'>Item { purchaseData?.count !== 1 && !!purchaseData?.count && `(${ purchaseData?.count })`}</span>
                                 <span className='dark:text-major-dark'>{purchaseData?.item}</span>
                              </div>
                              {
                                 purchaseData?.shipping >= 0 && <div className='flex flex-row justify-between items-center text-sm gap-2'>
                                    <span className='dark:text-major-dark'>Shipping</span>
                                    <span className='dark:text-major-dark'>{purchaseData?.shipping === 0 ? 'Free' : `${ purchaseData?.shipping } USD`}</span>
                                 </div>
                              }
                              {
                                 !!purchaseData?.extras?.length &&
                                 purchaseData.extras.map((it, i) => {
                                    return (
                                       <div
                                          key={ i }
                                          className='flex flex-row justify-between items-center text-sm gap-2 text-major dark:text-major-dark'
                                       >
                                          <span>{it.name}</span>
                                          <span>{it.price} USD</span>
                                       </div>
                                    )
                                 })
                              }
                              <div className=' border-t-[1px]'></div>
                              <div className='flex flex-row justify-between items-center text-sm font-medium gap-2'>
                                 <span className='dark:text-major-dark'>Total</span>
                                 <span className='dark:text-major-dark'>{purchaseData?.total} USD</span>
                              </div>
                           </div>
                        </div>
                        {/* <div className='flex flex-col gap-2 items-start'>
                     <span className='text-sm font-medium'>Promo code</span>
                     <div className='flex flex-row gap-2 w-full'>
                        <Input
                           height='10'
                           className={ `${ isMobile ? 'w-full' : '!w-[238px]' }` }
                           value={ promo }
                           placeholder='Enter your code'
                           onChange={ (_, value) => setPromo(value) }
                        />
                        <div className={ `!w-[81px]` }>
                           <Button
                              text='Apply'
                              primaryColor
                              backgroundColor='transparent'
                              borderRadius='large'
                              textSize='small'
                              padding='none'
                              textMarginX='0'
                              classNames={ `border h-10 px-[14px] py-[10px]` }
                           />
                        </div>
                     </div>
                  </div> */}
                     </div>
                  </div> : null
            }
            {
               type === 'store' ?
                  (!!wallet || !!one_click) &&
                  <div className='w-full flex flex-col items-center justify-center mt-6'>
                     <span className='text-sm font-medium dark:text-major-dark mb-2 text-start w-full'>Payment method</span>
                     {
                        !!wallet && (
                           <div className='w-full mb-4'>
                              <Item
                                 isChecked={ selectedMethod === 'wallet' }
                                 setPaymentMethod={ setPaymentMethod }
                                 balance={ wallet.balance }
                                 type='wallet'
                              />
                           </div>
                        )
                     }
                     {
                        !!one_click && (
                           <div className='w-full mb-4'>
                              <Item
                                 isChecked={ selectedMethod === 'one_click' }
                                 setPaymentMethod={ setPaymentMethod }
                                 type='one_click'
                                 savedPaymentMethod={ savedPaymentMethod }
                                 oneClick={ one_click }
                              />
                              {
                                 diffPerecentage >= 50 &&  selectedMethod === 'one_click'  && (
                                    <PaymentWarningLimit diff={ diff } />
                                 )
                              }
                           </div>
                        )
                     }
                     {
                        !!another_payment_options && (
                           <>
                              <Item
                                 isChecked={ selectedMethod === 'other' }
                                 setPaymentMethod={ setPaymentMethod }
                                 type='other'
                              />
                              {
                                 diffPerecentage >= 50 &&  selectedMethod === 'other'  && (
                                    <PaymentWarningLimit diff={ diff } />
                                 )
                              }
                           </>
                        )
                     }
                     <div className='h-9 mt-3 flex items-center w-auto'>
                        <Button
                           text='Payment FAQs'
                           primaryColor
                           onClick={ () => { IntercomMoreInfo(MEMBER_PAYMENT_FAQS) } }
                           borderRadius='large'
                           fontIconSize='base'
                           textSize='base'
                           iconName='help'
                           backgroundColor='transparent'
                           classNames='h-full px-3'
                           padding='none'
                           alignment='center'
                           iconPosition='left'
                        />
                     </div>
                  </div>
                  : <div className='w-full flex flex-col items-center justify-center p-5'>
                     {
                        !!wallet && (
                           <div className='w-full mb-4'>
                              <Item
                                 isChecked={ selectedMethod === 'wallet' }
                                 setPaymentMethod={ setPaymentMethod }
                                 balance={ wallet.balance }
                                 type='wallet'
                              />
                           </div>
                        )
                     }
                     {
                        !!one_click && (
                           <div className='w-full mb-4'>
                              <Item
                                 isChecked={ selectedMethod === 'one_click' }
                                 setPaymentMethod={ setPaymentMethod }
                                 type='one_click'
                                 savedPaymentMethod={ savedPaymentMethod }
                                 oneClick={ one_click }
                              />
                              {
                                 diffPerecentage >= 50 &&  selectedMethod === 'one_click'  && (
                                    <PaymentWarningLimit diff={ diff } />
                                 )
                              }
                           </div>
                        )
                     }
                     {
                        !!another_payment_options && (
                           <>
                              <Item
                                 isChecked={ selectedMethod === 'other' }
                                 setPaymentMethod={ setPaymentMethod }
                                 type='other'
                              />
                              {
                                 diffPerecentage >= 50 &&  selectedMethod === 'other'  && (
                                    <PaymentWarningLimit diff={ diff } />
                                 )
                              }
                           </>
                        )
                     }
                     <div className='h-9 mt-3 flex items-center w-auto'>
                        <Button
                           text='Payment FAQs'
                           primaryColor
                           onClick={ () => { IntercomMoreInfo(MEMBER_PAYMENT_FAQS) } }
                           borderRadius='large'
                           fontIconSize='base'
                           textSize='base'
                           iconName='help'
                           backgroundColor='transparent'
                           classNames='h-full px-3'
                           padding='none'
                           alignment='center'
                           iconPosition='left'
                        />
                     </div>
                     {
                        isDisabled && selectedMethod === 'one_click' && (
                           <p className='mt-3 mb-1 text-sm text-secondary dark:text-secondary-dark leading-tight'>PROCESSING PAYMENT...</p>
                        )
                     }
                     {
                        type !== 'store' &&
                        <div className='h-12 mt-5 w-full'>
                           <Button
                              text={ buttonText }
                              textSize='base'
                              iconPosition='left'
                              fontIconSize='base'
                              primaryColor
                              borderRadius='large'
                              classNames='h-full py-2'
                              padding='none'
                              disabled={ isDisabled }
                              isLoading={ isDisabled }
                              onClick={ buttonAction }
                           />
                        </div>

                     }
                  </div>
            }
         </div>
         {
            type === 'store' &&
               <div className={ `h-9 mb-6 px-6 w-full ${ !isMobile && (!!one_click || !!wallet) && '!w-[343px] mx-auto' }` }>
                  <Button
                     text='Pay'
                     textSize='base'
                     iconPosition='left'
                     fontIconSize='base'
                     primaryColor
                     borderRadius='large'
                     classNames='h-full py-2'
                     padding='none'
                     disabled={ isDisabled }
                     isLoading={ isDisabled }
                     onClick={ buttonAction }
                  />
               </div>
         }
      </div>
   );
};

const Item = ({
   isChecked,
   balance,
   type,
   setPaymentMethod,
   savedPaymentMethod,
   oneClick,
   className,
}) => {
   let system = {
      segpay: { maxWidth: '88px', src: paymentMethodImage.segpay },
      paypal: { maxWidth: '65px', src: paymentMethodImage.paypal },
      ccbill: { maxWidth: '60px', src: paymentMethodImage.ccbill },
   }
   const paymentImg = oneClick && oneClick.payment_system && system[oneClick.payment_system];
   let cardSrc = '';
   let oneClickCardType = 'Card'
   if(oneClick && oneClick.card_type) {
      cardSrc = paymentMethodImage[oneClick.card_type];
      if(oneClick.card_type === 'visa'){
         oneClickCardType = 'Visa';
      } else if(oneClick.card_type === 'mastercard') {
         oneClickCardType = 'Master';
      }
   }
   return (
      <div
         onClick={ () => setPaymentMethod(type) }
         role='presentation'
         className={ `w-full rounded-lg p-2 flex justify-center select-none relative border ${ isChecked ? 'skin-primary-border' : 'border-divider cursor-pointer dark:border-divider-dark' }` }
      >
         <div className={ `w-full ${ !!savedPaymentMethod ? 'flex' : '' }` }>
            {
               isChecked && (
                  <div className={ `h-5 w-5 flex items-center justify-center absolute right-0 top-0 m-1 ${ className }` }>
                     <Icon name='circle-checked' color='' className='skin-primary-text' size='lg' />
                  </div>
               )
            }
            {
               !!className && !isChecked && (
                  <div className={ `h-5 w-5 flex items-center justify-center absolute right-0 top-0 m-1 ${ className }` }>
                     <Icon name='circle-unchecked' color='' className='border-grey-arya  dark:border-grey-dm' size='lg' />
                  </div>
               )
            }
            {
               type === 'wallet' && (
                  <div className='flex'>
                     <div className='flex items-center justify-center'>
                        <div className='w-10 h-10 bg-grey-main rounded-full flex justify-center items-center dark:bg-black-field'>
                           <Icon name='wallet' primaryColor={ window.skinSecondaryColor } className='skin-primary-text' size='lg' />
                        </div>
                     </div>
                     <div className={ `flex flex-col ml-4` }>
                        <span className={ `block leading-tight text-major ${ !!savedPaymentMethod ? '' : 'mt-2' } dark:text-major-dark` }>
                           <span dangerouslySetInnerHTML={ {
                              __html: getSiteTitle(),
                           } } /> wallet
                        </span>
                        <span className={ `'block font-medium leading-none text-sm text-placeholder dark:text-placeholder-dark mb-1 ${ !!savedPaymentMethod ? 'mt-1' : 'mt-2' }` }>
                           Available balance: { numberFormatter.withDots(balance) } USD
                        </span>
                     </div>
                  </div>
               )
            }
            {
               type === 'one_click' && (
                  <>
                     <div className='flex'>
                        {
                           oneClick?.card_type && (
                              <div
                                 className={ `h-10 w-10 flex items-center justify-center rounded-full overflow-hidden border border-divider p-px ${ paymentMethodImage[oneClick.card_type] ? 'bg-panel' : 'dark:border-divider-dark' }` }>
                                 {
                                    paymentMethodImage[oneClick.card_type] && (
                                       <img src={ cardSrc } alt='card' className='object-contain object-center w-auto h-auto '  />
                                    )
                                 }
                                 {
                                    !paymentMethodImage[oneClick.card_type] && (
                                       <span className='text-center text-major dark:text-major-dark'
                                          style={ {
                                             fontSize: '8px',
                                          } }
                                       >{oneClick.card_type.charAt(0).toUpperCase() + oneClick.card_type.slice(1)}</span>
                                    )
                                 }
                              </div>
                           )
                        }
                        <div className='flex flex-col ml-4'>
                           <span className='text-major font-medium leading-tight dark:text-secondary-dark'>My {oneClickCardType} ending in {oneClick?.last_4_digits}</span>
                           <span className='text-secondary dark:text-secondary-dark text-xs'> Payment processor:</span>
                           <div className=' mt-1 flex items-center justify-start'>
                              <img
                                 style={ {
                                    maxWidth: paymentImg?.maxWidth,
                                 } }
                                 src={ paymentImg?.src } alt={ paymentImg?.src } className='w-auto h-auto object-contain' />
                           </div>
                        </div>
                     </div>
                  </>
               )
            }
            {
               type === 'other' && (
                  <div className='w-full rounded-lg px-1 flex items-center justify-between cursor-pointer'>
                     <div>
                        <span className='block leading-tight text-major dark:text-major-dark'>
                           Choose another payment method
                        </span>
                     </div>
                  </div>
               )
            }
         </div>
      </div>
   );
};


const PaymentWarningLimit = ({ diff }) => {
   return (
      <div className='flex flex-col mt-4 mx-auto'>
         <span className='text-sm text-secondary dark:text-secondary-dark leading-16px'>CREDIT CARD PAYMENT LIMITS</span>
         <span className='text-xs text-major dark:text-major-dark mt-2 leading-14px'>You have a maximum of {diff <= 0 ? 0 : diff} credit card payments remaining in the next 30 days. Please contact support if you would like this increased.</span>
         <div className='h-9 mt-3 flex items-center w-auto'>
            <Button
               text='Contact support'
               primaryColor
               onClick={ () => IntercomMoreInfo(CONTACT_SUPPORT) }
               borderRadius='large'
               fontIconSize='base'
               textSize='base'
               iconName='attention-outline'
               backgroundColor='transparent'
               classNames='h-full px-3'
               padding='none'
               alignment='center'
               iconPosition='left'
            />
         </div>
      </div>
   )
}

ChoosePaymentType.propTypes = {
   onModalClose: PropTypes.func,
   onContinue: PropTypes.func,
   type: PropTypes.string,
   isDisabled: PropTypes.bool,
   savedPaymentMethod: PropTypes.object,
   methods: PropTypes.object,
   onOneClickPay: PropTypes.func,
   showNewStyles: PropTypes.bool,
   purchaseData: PropTypes.object,
   isMobile: PropTypes.number,
};

Item.propTypes = {
   setPaymentMethod: PropTypes.func,
   isChecked: PropTypes.bool,
   savedPaymentMethod: PropTypes.object,
   balance: PropTypes.number,
   type: PropTypes.string,
   oneClick: PropTypes.object,
   className: PropTypes.string,
}

Item.defaultProps = {
   className: '',
}

PaymentWarningLimit.propTypes = {
   diff: PropTypes.number,
}

ChoosePaymentType.defaultProps = {
   onModalClose: () => {},
   onContinue: () => {},
   chooseAnotherPayment: () => {},
   purchaseData: {},
}
export { Item };
export default React.memo(ChoosePaymentType);
